"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Poll = exports.waitPromise = exports.convertToExtendedAsset = exports.MyMoney = exports.parseJSON = exports.toHash = void 0;
const data_entities_1 = require("@waves/data-entities");
const toHash = (arr, field) => {
    return arr.reduce((acc, item) => {
        const key = String(item[field]);
        acc[key] = item;
        return acc;
    }, Object.create(null));
};
exports.toHash = toHash;
const JSON_Parser_reg = new RegExp('((?!\\\\)"\\w+"):\\s*(-?[\\d|\.]{14,}(e-?\\d+)?)', 'g');
const parseJSON = function (string) {
    return JSON.parse(string.replace(JSON_Parser_reg, `$1:"$2"`));
};
exports.parseJSON = parseJSON;
class MyMoney extends data_entities_1.Money {
    constructor(coins, asset) {
        super(coins, asset);
    }
    cloneWithCoins(coins) {
        const money = super.cloneWithCoins(coins);
        return new MyMoney(money.getCoins(), this.asset);
    }
    cloneWithTokens(tokens) {
        const money = super.cloneWithTokens(tokens);
        return new MyMoney(money.getCoins(), this.asset);
    }
}
exports.MyMoney = MyMoney;
const convertToExtendedAsset = (asset, iconApiUrl) => {
    const { data, metadata } = asset;
    const { has_script, description, min_sponsored_fee, height, id, name, precision, quantity, reissuable, sender, ticker, timestamp } = data;
    const newAsset = new data_entities_1.Asset({
        id,
        height,
        name,
        precision,
        description,
        quantity,
        reissuable,
        sender,
        ticker,
        timestamp: new Date(timestamp),
        hasScript: has_script,
        minSponsoredFee: min_sponsored_fee
    });
    return Object.assign(newAsset, {
        hasImage: metadata.has_image,
        icon: metadata.has_image ? `${iconApiUrl}/${newAsset.id}.svg` : null,
        verifiedStatus: metadata.verified_status
    });
};
exports.convertToExtendedAsset = convertToExtendedAsset;
const waitPromise = (timeMs) => new Promise((res) => setTimeout(res, timeMs));
exports.waitPromise = waitPromise;
class Poll {
    constructor(timeMs, action, onData) {
        this.timeMs = timeMs;
        this.isWorked = false;
        this._cb = action;
        this._cbOut = onData;
    }
    start() {
        this.isWorked = true;
        this._start();
    }
    stop() {
        this.isWorked = false;
    }
    _start() {
        return __awaiter(this, void 0, void 0, function* () {
            while (true) {
                if (!this.isWorked) {
                    return;
                }
                try {
                    const res = yield this._cb();
                    if (this._cbOut) {
                        this._cbOut(res);
                    }
                }
                catch (e) {
                }
                yield exports.waitPromise(this.timeMs);
            }
        });
    }
}
exports.Poll = Poll;
